export const ORDER_URL = {
  root: '/api/v1/customer',
  category: '/category/all',
  tiles: '/tiles/all',
  subCategory: '/subcategory/all',
  product: '/item/all',
  browseUrl : 'shop',
  siteTitle:'Wild Birds Unlimited',
  cart: {
    base: '/cart',
    erplyBase: '/erply/cart',
    add: '/add',
    update: '/update',
    remove: '/remove',
    tax: '/tax/details'
  },
  paymentInfo: '/payment/info',
  shippingCharge: '/api/v1/customer/shipping/charge/all',
  checkout: '/cart/checkout',
  guestCheckout: '/cart/guest/checkout',
  order: {
    base: '/order',
    payment: '/payment',
    initPayment: '/initialize/payment',
    savedPayment: '/payment/savedcard',
    newCard: '/newcard',
    summary: '/summary',
    recentOrder: '/summary',
    reOrder: '/reorder'
    
  },
  cards:{
	  base:'/wbu/customer/card',
	  update:'/Initializecardinfo',
	  card:'/card',
    remove:'/remove',
    heartlandUpdate:'/card/update',
    monerisProcess:'/process'
  }, 
   currencyType:{
    US : 'USD',
    CA : 'CAD'
  },
  discount:{
	  amount:'/discount?discountCode='
  },
  countries:{
    list:'/region/country'
  },
  heartland:'/heartland',
  tsys:'/tsys',
  moneris:'/moneris',
  paypal:'/paypal'
};

export const PAYMENT_TYPE = {
  heartLand: 'HeartLand',
  worldPay:'WorldPay',
  tsys:'Tsys',
  moneris:'Moneris',
  paypal:'paypal'
};

export const MONERIS_LOADED = {
  loaded : false,
  update_page_loaded : false
};

export const USER_ACTION = {
  REORDER: 'REORDER',
  PROFILE_UPDATE:'PROFILE_UPDATE',
  NEW_DSC_MEMBER:'NEW_DSC_MEMBER',
  DSC_RENEWAL:'DSC_RENEWAL',
  DSC_RETURN:'DSC_RETURN',
  STORE_SWITCH:'STORE_SWITCH',
  RENEW_DSC_BUTTON:'RENEW_DSC_BUTTON',
  GUEST_REGISTERATION:'GUEST_REGISTERATION',
  GUEST_OPTING:'GUEST_OPTING',
  PAYPAL: 'PAYPAL',
  PAY_LATER: 'PAY_LATER',
  VENMO: 'VENMO'
};

export const DISPLAY_IN = {
  PRODUCT: 'PRODUCT'
};

export const REMAINDER_TYPE = {
  OUT_OF_STOCK: 'OUT_OF_STOCK'
};

export const SESSION_STORAGE = {
  OUT_OF_STOCK_REMAINDERS: 'OUT_OF_STOCK_REMAINDERS'
};

export const FEDEX_ERROR_DETAILS = {
  address_errorCodes : [313,317,420,507,520,521,522,526,705,706,707,708,710,711,712,819,820,821,822,835,836,838,839,864,865,866,916,917,925,965,970,975,984,1002,1003]
};

export const CLOSED_STORE = {
  storeCode : '995'
};

export const LIMITATIONS = {
  noOfItemsAllowed : 40
};

export const TILES_TYPE = {
  category: 'CATEGORY',
  subcategory: 'SUBCATEGORY'
};

export default {ORDER_URL,PAYMENT_TYPE,MONERIS_LOADED,FEDEX_ERROR_DETAILS, USER_ACTION,REMAINDER_TYPE,SESSION_STORAGE,CLOSED_STORE,DISPLAY_IN,LIMITATIONS,TILES_TYPE};



// WEBPACK FOOTER //
// ./src/app/order/constants.js